import { TreeNode } from 'primeng/api';
import { ViewModel } from '../view-model';
import { TreeNodeSelectionState } from './tree-node-selection-state';
;

export class MitigationTreeOption implements ViewModel, TreeNode {
  public friendlyTypeNameSingular: string = 'MitigationTreeOption';
  public apiRoute: string;

  public label: string;
  public data: string;
  public parentData: string;
  public leaf: boolean;
  public children: MitigationTreeOption[];
  public expanded: boolean;
  public partialSelected: boolean;
  public hasChildren: boolean;
  public selectionState: TreeNodeSelectionState;
  public level = 0;
  public selectable: boolean;
  public runnableModelOrgTreeNodeId: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data: any): void {
    this.label = data.label;
    this.data = data.data;
    this.parentData = data.parentData;
    this.leaf = !data.hasChildren;
    this.children = [];
    this.selectionState = data.selectionState;
    this.selectable = data.selectable;
    this.runnableModelOrgTreeNodeId = data.runnableModelOrgTreeNodeId;
  }
}
